import { AbilityService } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { AgentType } from 'mbs-ui-shared@models/Computer';

export const getTabsConfig = (i18N: I18NextPipe, ability: AbilityService) => {
  const tabs: Array<
    Partial<{
      id: string;
      title: string;
      icon: string;
      updateAlert: string;
      image: string;
      imageWidth: number;
      beta: boolean;
    }>
  > = [
    {
      id: AgentType.Backup,
      title: i18N.transform('products.backup'),
      icon: 'mbs-agent mbs-agent_backup downloads_agent-icon',
      updateAlert: 'showBackupUpdateDot'
    },
    {
      id: AgentType.RMM,
      title: i18N.transform('products.rmm'),
      icon: 'mbs-agent mbs-agent_rmm downloads_agent-icon',
      updateAlert: 'showRmmUpdateDot'
    },
    {
      id: AgentType.RA,
      title: i18N.transform('products.remote_desktop'),
      icon: 'mbs-agent mbs-agent_connect downloads_agent-icon',
      updateAlert: 'showRAUpdateDot'
    },
    {
      id: 'bootableUSB',
      title: i18N.transform('products.bootableUSB'),
      image: 'assets/images/icons/bootable-usb.svg'
    },
    {
      id: AgentType.NetworkDiscovery,
      title: i18N.transform('products.networkDiscovery', { format: 'title' }),
      image: 'assets/images/icons/network.svg',
      imageWidth: 20,
      beta: true
    }
  ];

  if (ability.can('read', 'HelpMarketing')) {
    tabs.push({
      id: 'guides',
      title: i18N.transform('shared:guides', { format: 'title' }),
      image: 'assets/images/icons/guides.svg',
      imageWidth: 16
    });
  }

  return tabs;
};

export enum BuildAction {
  Download = 'download',
  CopyLink = 'copyLink',
  CopyCommand = 'copyCommand'
}

export enum CopyingStatus {
  Copying = 'copying',
  Copied = 'copied'
}

export enum BuildTopicStatus {
  Success = 'Success'
}
